/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-mixins, warp-drive/no-legacy-request-patterns */
// Extends From
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';

// Internal Imports
import EditPostMixin from '@linc-technologies/linced-common/mixins/edit-post';
import PostTypes from '@linc-technologies/linced-common/enums/post-type';
import PageType from 'linced-app/enums/page-type';

// Ember Imports
import { action, computed } from '@ember/object';
import { isEmpty } from '@ember/utils';
import { setDiff } from '@ember/object/computed';
import { service } from '@ember/service';

export default class IndexController extends Controller.extend(EditPostMixin) {
  // Constants
  queryParams = [
    'authorIds',
    'autoFilter',
    'endTime',
    'offset',
    'searchQuery',
    'startTime',
  ];

  PostTypes = PostTypes;
  PageType = PageType;

  // Services
  @service
  store;

  @service
  toaster;

  // State
  @tracked
  authorIds = [];

  @tracked
  autoFilter = '';
  @tracked
  endTime = '';
  @tracked offset = 0;
  @tracked searchQuery = '';
  @tracked
  startTime = '';

  // Dynamic
  @computed('offset', 'model.{dailyNotices.[],globalNotices.[]}')
  get posts() {
    if (this.offset === 0 && !isEmpty(this.model.globalNotices)) {
      return [
        ...this.model.dailyNotices.slice(),
        ...this.model.globalNotices.slice(),
      ];
    }
    return this.model.dailyNotices;
  }

  @computed('authorIds.[],model.authors.[]')
  get selectedAuthors() {
    return this.authorIds.map((id) => {
      return this.store.peekRecord('person', id);
    });
  }

  @setDiff('model.authors', 'selectedAuthors')
  remainingAuthors;

  @computed('remainingAuthors')
  get sortedRemainingAuthors() {
    return this.remainingAuthors
      .slice()
      .sort(
        (a, b) =>
          (a.lastName || '').localeCompare(b.lastName || '') ||
          (a.firstName || '').localeCompare(b.firstName || ''),
      );
  }

  // Functions
  @action
  addAuthor(author) {
    if (this.authorIds.length >= 5) {
      this.toaster.error(
        'Filtering has a maximum of 5 authors. Please remove one before adding more.',
      );
    } else {
      this.authorIds = [...this.authorIds, author.get('id')];
    }
  }

  @action
  removeAuthor(author) {
    let id = author.get('id');
    this.authorIds = this.authorIds.filter((authorId) => authorId !== id);
  }

  @action
  setStartTime(startTime) {
    this.startTime = startTime;
    this.autoFilter = '';
  }

  @action
  setEndTime(endTime) {
    this.endTime = endTime;
    this.autoFilter = '';
  }

  @action
  clear() {
    this.startTime = '';
    this.endTime = '';
    this.autoFilter = '';
    this.authorIds = [];
  }

  @action
  filterDay() {
    this.autoFilter !== 'day'
      ? (this.autoFilter = 'day')
      : (this.autoFilter = '');
    this.startTime = '';
    this.endTime = '';
  }

  @action
  filterWeek() {
    this.autoFilter !== 'week'
      ? (this.autoFilter = 'week')
      : (this.autoFilter = '');
    this.startTime = '';
    this.endTime = '';
  }

  @action
  filterSevenDays() {
    this.autoFilter !== '7-days'
      ? (this.autoFilter = '7-days')
      : (this.autoFilter = '');
    this.startTime = '';
    this.endTime = '';
  }

  @action
  refresh() {
    this.model.dailyNotices.update();
    this.model.globalNotices.update();
  }

  @action
  nextPage() {
    this.incrementProperty('offset', 20);
  }

  @action
  prevPage() {
    this.decrementProperty('offset', 20);
  }

  @action
  setSearchQuery(value) {
    this.searchQuery = value;
    this.offset = 0;
  }
}
